export default __webpack_public_path__ + "static/media/growth.6a2fbf4c.svg";